import React from "react";
import styled from "styled-components";

export const Logo = styled.div`
  font-size: ${({ size }) => size || "32px"};
  font-family: "SBAggroB", sans-serif;
  color: var(--fg-primary);
  letter-spacing: 1.5px;
`;
export default Logo;
